export default {
  favoriteActivity ({ state, commit }) {
    commit('favoriteActivity')
  },
  unfavoriteActivity ({ state, commit }) {
    commit('unfavoriteActivity')
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-summary/store/actions.js